import {
  GET_AGILE_PURCHASE_BUYERS,
  GET_AGILE_PURCHASE_BUYERS_SUCCESS,
  GET_AGILE_PURCHASE_BUYERS_ERROR
} from './AgilePurchaseBuyers.actions'

const initialState = {
  data: [],
  csv: [],
  loading: false,
  error: null
}
/**
 * Agile Purchase Buyer's reducer.
 */
const agilePurchaseBuyersReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_AGILE_PURCHASE_BUYERS:
      return { ...state, loading: true }
    case GET_AGILE_PURCHASE_BUYERS_SUCCESS:
      return { ...state, csv: payload.csv, data: payload.data, loading: false }
    case GET_AGILE_PURCHASE_BUYERS_ERROR:
      return { ...state, error: payload.error, loading: false, data: [] }
    default:
      return state
  }
}

export default agilePurchaseBuyersReducer
